/**
 * Created by andrey on 18.03.2026
 *
 * https://dev.vk.com/ru/bridge/VKWebAppStorageSet
 * 1000 key-values, 1000 set+get per hour,
 * 4096 value length limit, 2236 limit for JSON serialized string (for double serialization)
 */

class VKTransportAdapter {
    constructor() {
        this.pagesData = new PagesTransportData();
        this.rateLimit = new RateLimitTransport();

        this.config = {
            sendInterval: 10000,
            loadSessionInterval: 30000
        };
    }

    canSaveData() {
        const debugMode = connector.config.debugMode;
        debugMode && console.log(`sync countRequests ${this.rateLimit.countRequests()}`);

        return this.rateLimit.canMakeRequests();
    }

    saveData(data, options, onSuccess, onFailure) {
        const debugMode = connector.config.debugMode;

        let pages = {};

        if (options.syncout) {
            pages = this.pagesData.clearData();
        }

        pages = Object.assign(pages, this.pagesData.addData(data));

        if (!this.rateLimit.canMakeRequests(Object.keys(pages).length)) {
            onFailure("rateLimit");
            return;
        }

        debugMode && console.log("sync saving data to VK storage:", pages);

        let promise = Promise.resolve({});

        Object.entries(pages).forEach(([key, value]) => {
            promise = promise.then(() => {
                this.rateLimit.onRequest();
                return vkBridge.send("VKWebAppStorageSet", { key, value });
            });
        });

        promise.then(onSuccess)
            .catch((e) => {
                console.log("sync VKWebAppStorageSet error", e);

                const message = e && e.error_data && (e.error_data.error_reason || e.error_data.error_description) || "";
                if (message.includes("too many requests")) {
                    this.rateLimit.onRateLimit();
                }

                onFailure(e);
            });
    }

    loadSession(onSuccess, onFailure) {
        const debugMode = connector.config.debugMode;

        const sessionPageKey = this.pagesData.getSessionPageKey();

        vkBridge.send("VKWebAppStorageGet", { keys: [sessionPageKey] })
            .then((data) => {
                data.keys = (data.keys || []).filter((item) => item.value);

                debugMode && console.log("sync loaded session from VK storage:", data);

                data = data.keys.reduce((acc, item) => {
                    acc[item.key] = item.value;
                    return acc;
                }, {});

                data = this.pagesData.parseResponse(data);
                onSuccess(data && data.session);
            })
            .catch(onFailure);
    }

    loadData(onSuccess, onFailure) {
        const debugMode = connector.config.debugMode;

        const keys = this.pagesData.getAllPagesKeys();

        vkBridge.send("VKWebAppStorageGet", { keys })
            .then((data) => {
                data.keys = (data.keys || []).filter((item) => item.value);

                debugMode && console.log("sync loaded data from VK storage:", data);

                data = data.keys.reduce((acc, item) => {
                    acc[item.key] = item.value;
                    return acc;
                }, {});

                this.pagesData.setData(data);

                data = this.pagesData.parseResponse(data);
                onSuccess(data);
            })
            .catch(onFailure);
    }
}